import React from 'react';
import '../../styles/SolucionesPublicitarias.css';

const MicroSitesAndLandings = () => {
  return (
    <section className="microsites-and-landing-section py-5">
      <div className="container">
        <div className="row align-items-center my-5 justify-content-between">
          {/* IMÁGENES SUPERPUESTAS EN EL CENTRO */}
          <div className="col-md-12 col-lg-5 position-relative d-flex justify-content-center dispositivos-mockup mt-4 mt-lg-0">
            <img
              src="assets/micrositio-1.png"
              alt="Desktop"
              className="img-fluid dispositivo desktop img-filter"
              data-aos="zoom-in"
              data-aos-delay="0"
            />
            <img
              src="assets/micrositio-2.png"
              alt="Laptop"
              className="img-fluid dispositivo laptop img-filter"
              data-aos="zoom-in"
              data-aos-delay="300"
            />
            <img
              src="assets/micrositio-3.png"
              alt="Tablet"
              className="img-fluid dispositivo tablet img-filter"
              data-aos="zoom-in"
              data-aos-delay="600"
            />
            <img
              src="assets/micrositio-4.png"
              alt="Mobile"
              className="img-fluid dispositivo mobile img-filter"
              data-aos="zoom-in"
              data-aos-delay="900"
            />
          </div>

          {/* TÍTULO A LA IZQUIERDA */}
          <div className="col-md-12 col-lg-6 mt-5">
            <div className='pb-2' data-aos="fade-up">
              <h2 className="title"><span>Micrositios y </span>landings</h2>
            </div>

            <div className='pb-2' data-aos="fade-up">
              <p>
                Como parte de nuestras soluciones de contenido, diseñamos micrositios integrales conectados
                a la red de BeHealth. Estos espacios personalizados aprovechan nuestro tráfico orgánico y
                pautado para maximizar la visibilidad, la permanencia y el impacto en tu audiencia.
              </p>

              <p>
                Con contenido audiovisual de alta calidad, ofrecemos una experiencia de usuario mejorada,
                creando un entorno exclusivo para abordar temas relevantes y posicionar tu marca como referente.
              </p>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};

export default MicroSitesAndLandings;

